module.exports = __webpack_public_path__ + "img/2_1-finanziario-ristorante-2.d8dd3952.png";